export enum OnlineOrderStatuses {
  Open = 'Open',
  Issued = 'Issued',
  Other = 'Other'
}
